export default __webpack_public_path__ + "static/media/work5.b9420f5a.png";